import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import dedent from 'dedent';

export default createPerformableConfig(
  'floorplan',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      interactive_tour: coerceBoolean().optional(),
      gla_report: coerceBoolean().optional(),
      cad_file: coerceBoolean().optional(),
      floorplan_3d: coerceBoolean().optional(),
      rush: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Floorplans',
    title: '2D Floorplans',
    group: 'Listing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/floorplan/thumbnail_v3.png',
    images: [],
    short: dedent`
      Our 2D floor plans provide clear layouts with precise measurements, while 3D floor \
      plans add depth, textures, and furniture placement for a lifelike experience. The GLA \
      report ensures accurate square footage calculations, helping buyers and agents verify \
      property value. Our Interactive Property Tour offers a seamless, virtual walkthrough, \
      allowing buyers to explore properties remotely.
    `,
  },
);
